// src/triage/index.ts
var TRIAGE_FLAGS = ["disputed", "archived"];
var TRIAGE_LABEL = Object.freeze({
  disputed: "Disputed",
  archived: "Archived"
});
var TRIAGE_MEANING = Object.freeze({
  disputed: "Someone in your tenant contests this transaction.",
  archived: "Hidden from default list views."
});
function triageFlagsOf(row) {
  const status = typeof row?.caller_status === "string" ? row.caller_status : "";
  return {
    disputed: row?.disputed === true || status === "disputed",
    archived: row?.archived === true || status === "archived"
  };
}
function triagePatch(flag, next) {
  return { [flag]: next };
}

export { TRIAGE_FLAGS, TRIAGE_LABEL, TRIAGE_MEANING, triageFlagsOf, triagePatch };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map